import { render } from "./DailyStatsDialog.vue?vue&type=template&id=6dd1f514&scoped=true&ts=true"
import script from "./DailyStatsDialog.vue?vue&type=script&lang=ts"
export * from "./DailyStatsDialog.vue?vue&type=script&lang=ts"

import "./DailyStatsDialog.vue?vue&type=style&index=0&id=6dd1f514&scoped=true&lang=css"

import exportComponent from "C:\\Users\\breno\\Documents\\Workspace\\Coll\\palavra-quadrada\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dd1f514"]])

export default __exports__